import type { BadgeType } from "../components/tables/tableContext/TableContext";

export const semanticBackgroundClasses: Record<string, string> = {
  primary: "bg-brand text-brand-foreground",
  secondary: "bg-surface-subtle text-muted-dark",
  success: "bg-success text-success-foreground",
  info: "bg-info text-info-foreground",
  warning: "bg-warning text-warning-foreground",
  danger: "bg-danger text-danger-foreground",
};

export const semanticSubtleBackgroundClasses: Record<string, string> = {
  primary: "bg-brand-subtle",
  secondary: "bg-gray-100",
  success: "bg-success-subtle",
  info: "bg-info-subtle",
  warning: "bg-warning-subtle",
  danger: "bg-danger-subtle",
  light: "bg-surface-subtle",
  dark: "bg-gray-200",
};

export const semanticTextClasses: Record<string, string> = {
  primary: "text-brand",
  secondary: "text-muted-dark",
  success: "text-success",
  info: "text-info",
  warning: "text-warning-foreground",
  danger: "text-danger",
  light: "text-white",
  dark: "text-gray-900",
};

export const semanticIconClasses: Record<string, string> = {
  primary: "[&_path]:!fill-brand [&_rect]:!fill-brand",
  secondary: "[&_path]:!fill-muted-dark [&_rect]:!fill-muted-dark",
  success: "[&_path]:!fill-success [&_rect]:!fill-success",
  info: "[&_path]:!fill-info [&_rect]:!fill-info",
  warning: "[&_path]:!fill-warning [&_rect]:!fill-warning",
  danger: "[&_path]:!fill-danger [&_rect]:!fill-danger",
  light: "[&_path]:!fill-white [&_rect]:!fill-white",
  dark: "[&_path]:!fill-gray-900 [&_rect]:!fill-gray-900",
};

export const getSemanticSubtleBackgroundClasses = (color = "primary") =>
  semanticSubtleBackgroundClasses[color.replace(/^light-/, "")] ??
  semanticSubtleBackgroundClasses.primary;

export const getSemanticTextClasses = (color = "primary") =>
  semanticTextClasses[color] ?? semanticTextClasses.primary;

export const getSemanticIconClasses = (color = "primary") =>
  semanticIconClasses[color] ?? semanticIconClasses.primary;

const badgeClasses: Record<NonNullable<BadgeType["badgeColor"]>, string> = {
  "light-danger": "bg-danger-subtle text-danger",
  "light-success": "bg-success-subtle text-success",
  "light-warning": "bg-warning-subtle text-warning-foreground",
  "light-info": "bg-info-subtle text-info",
  "light-primary": "bg-brand-subtle text-brand",
  danger: "bg-danger text-danger-foreground",
  success: "bg-success text-success-foreground",
  warning: "bg-warning text-warning-foreground",
  info: "bg-info text-info-foreground",
  primary: "bg-brand text-brand-foreground",
  secondary: "bg-surface-subtle text-muted-dark",
};

export const getBadgeClasses = (color?: BadgeType["badgeColor"]) =>
  badgeClasses[color ?? "light-info"];
